"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _excluded = ["onSelect", "children", "value", "isDisable", "className", "currentTheme"];
var _jsxFileName = "/codebuild/output/src2887346459/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/DropDown/lib/DropDown.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_8yivm2m99() {
  var path = "/codebuild/output/src2887346459/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/DropDown/lib/DropDown.js";
  var hash = "55686c4577872051a94f746507126788527f1b76";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src2887346459/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/DropDown/lib/DropDown.js",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 16
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 23
        },
        end: {
          line: 67,
          column: 1
        }
      },
      "2": {
        start: {
          line: 19,
          column: 27
        },
        end: {
          line: 19,
          column: 54
        }
      },
      "3": {
        start: {
          line: 36,
          column: 10
        },
        end: {
          line: 36,
          column: 96
        }
      },
      "4": {
        start: {
          line: 58,
          column: 10
        },
        end: {
          line: 58,
          column: 96
        }
      },
      "5": {
        start: {
          line: 69,
          column: 16
        },
        end: {
          line: 86,
          column: 1
        }
      },
      "6": {
        start: {
          line: 88,
          column: 18
        },
        end: {
          line: 94,
          column: 2
        }
      },
      "7": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 84
        }
      },
      "8": {
        start: {
          line: 96,
          column: 17
        },
        end: {
          line: 127,
          column: 1
        }
      },
      "9": {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 105,
          column: 11
        }
      },
      "10": {
        start: {
          line: 106,
          column: 23
        },
        end: {
          line: 113,
          column: 3
        }
      },
      "11": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 109,
          column: 5
        }
      },
      "12": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 108,
          column: 13
        }
      },
      "13": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 112,
          column: 5
        }
      },
      "14": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 20
        }
      },
      "15": {
        start: {
          line: 115,
          column: 2
        },
        end: {
          line: 126,
          column: 4
        }
      },
      "16": {
        start: {
          line: 129,
          column: 0
        },
        end: {
          line: 141,
          column: 2
        }
      },
      "17": {
        start: {
          line: 143,
          column: 0
        },
        end: {
          line: 152,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 19,
            column: 18
          },
          end: {
            line: 19,
            column: 19
          }
        },
        loc: {
          start: {
            line: 19,
            column: 27
          },
          end: {
            line: 19,
            column: 54
          }
        },
        line: 19
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 35,
            column: 24
          },
          end: {
            line: 35,
            column: 25
          }
        },
        loc: {
          start: {
            line: 36,
            column: 10
          },
          end: {
            line: 36,
            column: 96
          }
        },
        line: 36
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 57,
            column: 24
          },
          end: {
            line: 57,
            column: 25
          }
        },
        loc: {
          start: {
            line: 58,
            column: 10
          },
          end: {
            line: 58,
            column: 96
          }
        },
        line: 58
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 90,
            column: 13
          },
          end: {
            line: 90,
            column: 14
          }
        },
        loc: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 84
          }
        },
        line: 91
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 96,
            column: 17
          },
          end: {
            line: 96,
            column: 18
          }
        },
        loc: {
          start: {
            line: 96,
            column: 26
          },
          end: {
            line: 127,
            column: 1
          }
        },
        line: 96
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 106,
            column: 23
          },
          end: {
            line: 106,
            column: 24
          }
        },
        loc: {
          start: {
            line: 106,
            column: 30
          },
          end: {
            line: 113,
            column: 3
          }
        },
        line: 106
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 27
          },
          end: {
            line: 19,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 27
          },
          end: {
            line: 19,
            column: 45
          }
        }, {
          start: {
            line: 19,
            column: 49
          },
          end: {
            line: 19,
            column: 54
          }
        }],
        line: 19
      },
      "1": {
        loc: {
          start: {
            line: 36,
            column: 10
          },
          end: {
            line: 36,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 11
          },
          end: {
            line: 36,
            column: 22
          }
        }, {
          start: {
            line: 36,
            column: 26
          },
          end: {
            line: 36,
            column: 44
          }
        }, {
          start: {
            line: 36,
            column: 48
          },
          end: {
            line: 36,
            column: 82
          }
        }, {
          start: {
            line: 36,
            column: 87
          },
          end: {
            line: 36,
            column: 96
          }
        }],
        line: 36
      },
      "2": {
        loc: {
          start: {
            line: 58,
            column: 10
          },
          end: {
            line: 58,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 58,
            column: 11
          },
          end: {
            line: 58,
            column: 22
          }
        }, {
          start: {
            line: 58,
            column: 26
          },
          end: {
            line: 58,
            column: 44
          }
        }, {
          start: {
            line: 58,
            column: 48
          },
          end: {
            line: 58,
            column: 82
          }
        }, {
          start: {
            line: 58,
            column: 87
          },
          end: {
            line: 58,
            column: 96
          }
        }],
        line: 58
      },
      "3": {
        loc: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 15
          }
        }, {
          start: {
            line: 91,
            column: 19
          },
          end: {
            line: 91,
            column: 44
          }
        }, {
          start: {
            line: 91,
            column: 48
          },
          end: {
            line: 91,
            column: 84
          }
        }],
        line: 91
      },
      "4": {
        loc: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 103,
            column: 46
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 103,
            column: 19
          },
          end: {
            line: 103,
            column: 46
          }
        }],
        line: 103
      },
      "5": {
        loc: {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 109,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 109,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 107
      },
      "6": {
        loc: {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 110
      },
      "7": {
        loc: {
          start: {
            line: 124,
            column: 7
          },
          end: {
            line: 124,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 124,
            column: 54
          },
          end: {
            line: 124,
            column: 65
          }
        }, {
          start: {
            line: 124,
            column: 68
          },
          end: {
            line: 124,
            column: 81
          }
        }],
        line: 124
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0, 0, 0],
      "3": [0, 0, 0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "55686c4577872051a94f746507126788527f1b76"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_8yivm2m99 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_8yivm2m99();
var Wrapper = (cov_8yivm2m99().s[0]++, _styledComponents.default.div.attrs({
  className: 'g-Dropdown'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  position: relative;\n"]))));
var StyledDropdown = (cov_8yivm2m99().s[1]++, (0, _utils.withThemedStyles)(_styledComponents.default.select.attrs({
  className: "g-Dropdown-select",
  autocomplete: function autocomplete(props) {
    cov_8yivm2m99().f[0]++;
    cov_8yivm2m99().s[2]++;
    return (cov_8yivm2m99().b[0][0]++, props.autocomplete) || (cov_8yivm2m99().b[0][1]++, 'off');
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      background: transparent\n        url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCAxOTUuMzA0IDEyNS4zMDQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE5NS4zMDQgMTI1LjMwNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxnPgoJCTxwb2x5Z29uIHBvaW50cz0iNjIuNjUyLDEwMy44OTUgMCwyMS40MDkgMTI1LjMwNCwyMS40MDkgICAiIGZpbGw9IiMzYjNkNDAiLz4KCTwvZz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K')\n        center right/18px no-repeat;\n      appearance: none;\n      padding: 0.75em 0;\n      padding-right: 22px;\n      width: 100%;\n      border: none;\n      border-bottom: 1px solid #e6e6e6;\n      outline: none;\n      cursor: pointer;\n      &:focus {\n        border-color: ", ";\n        background: rgba(0, 0, 0, 0.05);\n      }\n      > option {\n        background: #ffffff;\n        padding: 3px;\n      }\n    "])), function (props) {
  cov_8yivm2m99().f[1]++;
  cov_8yivm2m99().s[3]++;
  return (cov_8yivm2m99().b[1][0]++, props.theme) && (cov_8yivm2m99().b[1][1]++, props.theme.button) && (cov_8yivm2m99().b[1][2]++, props.theme.button.backgroundColor) || (cov_8yivm2m99().b[1][3]++, '#1a84f1');
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      background: transparent\n        url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCAxOTUuMzA0IDEyNS4zMDQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE5NS4zMDQgMTI1LjMwNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxnPgoJCTxwb2x5Z29uIHBvaW50cz0iNjIuNjUyLDEwMy44OTUgMCwyMS40MDkgMTI1LjMwNCwyMS40MDkgICAiIGZpbGw9IiMzYjNkNDAiLz4KCTwvZz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K')\n        center right/18px no-repeat;\n      appearance: none;\n      padding: 0.75em 0;\n      padding-right: 22px;\n      width: 100%;\n      border: none;\n      outline: none;\n      cursor: pointer;\n      font-size: ", ";\n      &:focus {\n        border-color: ", ";\n        background: rgba(0, 0, 0, 0.05);\n      }\n      > option {\n        background: #ffffff;\n        padding: 3px;\n      }\n    "])), _themeMapper.evolutionTheme.typography.caption1.fontSize, function (props) {
  cov_8yivm2m99().f[2]++;
  cov_8yivm2m99().s[4]++;
  return (cov_8yivm2m99().b[2][0]++, props.theme) && (cov_8yivm2m99().b[2][1]++, props.theme.button) && (cov_8yivm2m99().b[2][2]++, props.theme.button.backgroundColor) || (cov_8yivm2m99().b[2][3]++, '#1a84f1');
}))));
var Chevron = (cov_8yivm2m99().s[5]++, _styledComponents.default.span.attrs({
  className: 'g-Dropdown-chevron-down'
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  &::before {\n    border-style: solid;\n    border-width: 0 0 0.1em 0.1em;\n    content: '';\n    height: 0.45em;\n    right: 0.45em;\n    position: absolute;\n    -webkit-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n    width: 0.45em;\n    bottom: 1em;\n  }\n"]))));
var ChevronRI = (cov_8yivm2m99().s[6]++, (0, _styledComponents.default)(_icon.default).attrs({
  className: 'g-Dropdown-chevron-down',
  iconColor: function iconColor(props) {
    cov_8yivm2m99().f[3]++;
    cov_8yivm2m99().s[7]++;
    return (cov_8yivm2m99().b[3][0]++, props.theme) && (cov_8yivm2m99().b[3][1]++, props.theme.quantityField) && (cov_8yivm2m99().b[3][2]++, props.theme.quantityField.minusColor);
  },
  iconName: 'arrow-down-s-line.svg',
  size: 25
}));
cov_8yivm2m99().s[8]++;
var DropDown = function DropDown(props) {
  cov_8yivm2m99().f[4]++;
  var _ref = (cov_8yivm2m99().s[9]++, props),
    onSelect = _ref.onSelect,
    children = _ref.children,
    value = _ref.value,
    isDisable = _ref.isDisable,
    className = _ref.className,
    _ref$currentTheme = _ref.currentTheme,
    currentTheme = _ref$currentTheme === void 0 ? (cov_8yivm2m99().b[4][0]++, _themeProvider.TicketShopTheme.EQUILIBRIUM) : _ref$currentTheme,
    remainingProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  cov_8yivm2m99().s[10]++;
  var handleSelect = function handleSelect(evt) {
    cov_8yivm2m99().f[5]++;
    cov_8yivm2m99().s[11]++;
    if (props.isDisable) {
      cov_8yivm2m99().b[5][0]++;
      cov_8yivm2m99().s[12]++;
      return;
    } else {
      cov_8yivm2m99().b[5][1]++;
    }
    cov_8yivm2m99().s[13]++;
    if (onSelect) {
      cov_8yivm2m99().b[6][0]++;
      cov_8yivm2m99().s[14]++;
      onSelect(evt);
    } else {
      cov_8yivm2m99().b[6][1]++;
    }
  };
  cov_8yivm2m99().s[15]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(StyledDropdown, (0, _extends2.default)({
    disabled: isDisable,
    onChange: handleSelect,
    value: value
  }, remainingProps, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 7
    }
  }), children), currentTheme === _themeProvider.TicketShopTheme.EQUILIBRIUM ? (cov_8yivm2m99().b[7][0]++, /*#__PURE__*/_react.default.createElement(Chevron, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 55
    }
  })) : (cov_8yivm2m99().b[7][1]++, /*#__PURE__*/_react.default.createElement(ChevronRI, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 69
    }
  })));
};
cov_8yivm2m99().s[16]++;
DropDown.propTypes = {
  children: _propTypes.default.arrayOf(_propTypes.default.node),
  onSelect: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /**
   * Indicate if the dropdown is disbaled
   */
  isDisable: _propTypes.default.bool,
  className: _propTypes.default.string,
  /** theme context */
  currentTheme: _propTypes.default.string,
  autocomplete: _propTypes.default.string
};
cov_8yivm2m99().s[17]++;
DropDown.defaultProps = {
  children: [],
  onSelect: null,
  value: '',
  isDisable: false,
  className: '',
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  currentTheme: _themeProvider.DEFAULT_THEME_CONTEXT.theme,
  autocomplete: ''
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(DropDown));